module.exports = __webpack_public_path__ + "static/media/new-account.983e3d3d.svg";